import PartnershipsPage from './PartnershipsPage';

export default PartnershipsPage;